import * as React from 'react';

import { Picture } from '@shared/components/helpers/picture';
import { ImgixBG, ImgixFit } from '@shared/utils/imgix';

import { IItemGroup } from '@admin/types/item_group';

export const Hero: React.FC<{
  selection: IItemGroup;
  width: number;
  height: number;
  className?: string;
}> = ({ selection, width, height, className }) => {
  const image = selection.hero_image;
  const source = image && image.state === 'uploaded' && image.source;

  return source ? (
    <Picture
      className={className}
      width={width}
      height={height}
      source={source}
      fit={ImgixFit.Fill}
      background={ImgixBG.White}
    />
  ) : (
    <img className={className} src="/missing.svg" />
  );
};
